import { render, staticRenderFns } from "./newStatement.vue?vue&type=template&id=41ea3d6c&scoped=true"
import script from "./newStatement.vue?vue&type=script&lang=js"
export * from "./newStatement.vue?vue&type=script&lang=js"
import style0 from "./newStatement.vue?vue&type=style&index=0&id=41ea3d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ea3d6c",
  null
  
)

export default component.exports